import React from 'react'

const About = () => {
  return (
    <div className="exquite-about">
      <h4>About</h4>
      <p>
        Exquite was established in 2015 to provide car rental services to the public for use. The company offers a wide variety of cars and even customized vehicles for prospective users. 
      </p>
    </div>
  )
}

export default About